import { combineReducers } from 'redux'

//import entidades from "./store"
import arquivosContrato from './arquivosContrato/store'
import arquivosLicitacao from './arquivosLicitacao/store'
import anexosRecursoConcedido from './anexosRecursoConcedido/store'
import arquivosAdvertenciaFornecedor from './arquivosAdvertenciaFornecedor/store'
import arquivosAtaRegistroPreco from './arquivosAtaRegistroPreco/store'
import arquivosBensImoveis from './arquivosBensImoveis/store'
import anexosObrasParadas from './anexosObrasParadas/store'
import arquivosPlanosAnuaisContratacoes from './arquivosPlanosAnuaisContratacoes/store'
import arquivosDespesasCartaoCorporativo from './arquivosDespesasCartaoCorporativo/store'
import arquivosPrestacaoContasAnual from './arquivosPrestacaoContasAnual/store'
import anexosAdiantamentosSuprimentos from './anexosAdiantamentosSuprimentos/store'
import anexosDetalhesPrestacao from './anexoDetalhesPrestacao/store'
import arquivosAssinadosEmpenhoCredor from './arquivosAssinadosEmpenhoCredor/store'

export default combineReducers({
    arquivosContrato,
    arquivosLicitacao,
    anexosRecursoConcedido,
    arquivosAdvertenciaFornecedor,
    arquivosAtaRegistroPreco,
    arquivosBensImoveis,
    anexosObrasParadas,
    arquivosPlanosAnuaisContratacoes,
    arquivosDespesasCartaoCorporativo,
    arquivosPrestacaoContasAnual,
    anexosAdiantamentosSuprimentos,
    anexosDetalhesPrestacao,
    arquivosAssinadosEmpenhoCredor,
})
